module.exports = __webpack_public_path__ + "assets/img/3.7a31cc64.jpg";